/**
 * Single shared TanStack-Query key factory for the caller's own audit
 * feed (`GET /api/account/me/audit`).
 *
 * Mirrors `teamConfigKey` (Wave 1.5 fix G-CC2): every query key tuple
 * for an authenticated read includes `accountId` so cross-account
 * cache reuse is impossible. If a member signs out and back in as a
 * different account, the previous owner's audit rows can't leak from
 * cache because the key changes.
 *
 * The key is `as const` so TanStack's typed query-key inference flows
 * through; pass the same `(accountId)` tuple to every useQuery /
 * setQueryData / invalidateQueries call.
 */
export const meAuditKey = (accountId: string | null) => ["me-audit", accountId] as const;

export type MeAuditKey = ReturnType<typeof meAuditKey>;
